import store from '../store';

// build route href from params
export function routeUrl(params = {}) {
	const s = store.getState().status;
	return `${s.baseUrl}${params.region ?? s.region}/${params.language ?? s.lang}/${params.family ?? s.family}/${params.media ?? s.media}/${params.key ?? s.dataKey}`;
}
